import { onUnmounted } from "vue";
import { useToast } from "@jfrog-ba/vue-ui-core";
import { jfToastEmitter, type JfToastEvents } from "@/use/useJfToastEmitter.ts";

// MUST be called once from a component setup (App.vue). It acquires the PrimeVue
// toast service via inject and bridges emitter events to it, so the rest of the
// app can trigger toasts from anywhere through the emitter.
export const useJfToastInjector = () => {
  const toast = useToast();

  const showToast = ({ type, config }: JfToastEvents["show"]): void => {
    toast[type](config);
  };

  const closeAllToasts = (): void => {
    toast.removeAll();
  };

  jfToastEmitter.on("show", showToast);
  jfToastEmitter.on("closeAll", closeAllToasts);

  onUnmounted(() => {
    jfToastEmitter.off("show", showToast);
    jfToastEmitter.off("closeAll", closeAllToasts);
  });
};
